import { TooltipButton } from '@/ui/TooltipButton';
import styled from 'styled-components';

export const HeaderBar = styled.div`
  position: sticky;
  top: 0;
  z-index: 6;
  display: flex;
  align-items: center;
  gap: 4px;
  min-height: 52px;
  padding: 7px 12px;
  background: ${({ theme }) => theme.color.surfaceChrome};
  border-bottom: 1px solid ${({ theme }) => theme.color.glassBorder};
  > h2 {
    margin: 0 auto 0 4px;
    font-family: ${({ theme }) => theme.font.body};
    font-size: ${({ theme }) => theme.fontSize.xs};
    font-weight: 600;
    color: ${({ theme }) => theme.color.textMuted};
    text-transform: none;
    letter-spacing: normal;
  }
  > h2::before {
    display: none;
  }
`;

export const RailHeaderButton = styled(TooltipButton)`
  display: inline-grid;
  place-items: center;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 1px solid transparent;
  border-radius: ${({ theme }) => theme.radius.md};
  background: transparent;
  color: ${({ theme }) => theme.color.textMuted};
  cursor: pointer;
  transition:
    background 140ms ease,
    color 140ms ease;
  &:hover {
    background: ${({ theme }) => theme.color.hover};
    color: ${({ theme }) => theme.color.textPrimary};
  }
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.color.focusRing};
    outline-offset: 2px;
  }
  &[data-customizing='true'] {
    background: ${({ theme }) => theme.color.hover};
    color: ${({ theme }) => theme.color.accentCyan};
  }
  @media (pointer: coarse) {
    width: 44px;
    height: 44px;
  }
  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;
